import { SupabaseEnableClubFeaturesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { EnableClubFeatures } from '@/shared/domain'

export function makeEnableClubFeatures(): EnableClubFeatures {
  return new SupabaseEnableClubFeaturesRepository(makeSupabaseEdgeHttpClient()).execute
}
